@let _name = instance()?.name;
@if (_name) {
  <p>{{ _name }}</p>
} @else {
  <i style="opacity: 0.5">NULL</i>
}
